export const ROUTE_USER_SIGN_IN = '/entrar'
export const ROUTE_USER_SIGN_UP = '/cadastro'
export const ROUTE_USER_RECOVER_PASSWORD = '/recuperar-senha'
export const ROUTE_USER_CHANGE_PASSWORD = '/alterar-senha'
export const ROUTE_USER_RECOVER_PASSWORD_VERIFY = '/verificar-identidate'
export const ROUTE_USER_ACCOUNT = '/minha-conta'
export const ROUTE_USER_AFFILIATE_REGISTRATION = '/cadastro-afiliados'
export const ROUTE_USER_ORDERS = '/meus-pedidos'
export const ROUTE_USER_ADDRESSES = '/meus-enderecos'
export const ROUTE_USER_LOGOUT = '/sair'

export default {
  signIn: ROUTE_USER_SIGN_IN,
  signUp: ROUTE_USER_SIGN_UP,
  recoverPassword: ROUTE_USER_RECOVER_PASSWORD,
  changePassword: ROUTE_USER_CHANGE_PASSWORD,
  changePasswordVerify: ROUTE_USER_RECOVER_PASSWORD_VERIFY,
  userAccount: ROUTE_USER_ACCOUNT,
  userOrders: ROUTE_USER_ORDERS,
  userAddresses: ROUTE_USER_ADDRESSES,
  userLogOut: ROUTE_USER_LOGOUT,
}
